import clsx from 'clsx';
import { observer } from 'mobx-react';
import { Link } from '../../../../../../../Resource/Types';
import { T } from '../../../../../../../Translations';
import Button from '../../../../../../Form/Button';
import Modal from '../../../../../../Modal';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { Section } from '../../../../Types';

interface Props {
  store: LearningCollectionEditStore;
  section: Section;
  link: Link;
  close: () => void;
}

function ConfirmationModal({ store, section, link, close }: Props) {
  return (
    <Modal
      close={close}
      title={
        <h3 className="p-4 text-xl font-semibold">
          <T kind="Confirm Section Delete" />
        </h3>
      }
    >
      <p className="pb-4">
        <T
          kind="Are you sure you want to delete the section {{name}}? This..."
          name={section.resource.payload.name.text}
        />
      </p>
      <div className="flex justify-end">
        <Button
          type="button"
          value="Cancel"
          onClick={close}
          className="bg-white text-sm text-teal-600"
        />
        <Button
          type="button"
          value="Continue"
          onClick={() => store.deletingSection(section, link)}
          className={clsx(
            'ml-4 rounded-md bg-teal-600 px-8 py-2.5 text-sm font-semibold',
            'text-white',
          )}
        />
      </div>
    </Modal>
  );
}

export default observer(ConfirmationModal);
